import { Subheading } from "../design/heading";
import LogoHorizontal from "./LogoHorizontal";

interface Props {
  className?: string;
}

export const PoweredByLogo: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <Subheading className="mt-4 text-center">Powered by</Subheading>
      <LogoHorizontal
        href="https://www.casetime.com"
        className="items-center h-6 mx-auto mb-4"
      />
    </div>
  );
};
